import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropup d-inline-block" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "dropdown-menu" }
const _hoisted_4 = ["disabled", "aria-label"]
const _hoisted_5 = ["disabled", "aria-label"]
const _hoisted_6 = ["disabled", "aria-label"]

import { computed, ref } from "vue";
import { useStore } from "vuex";
import ScenarioType from "@/guiide/ts/scenarioType";
import ScenarioInfo from "@/guiide/ts/scenarioInfo";
import SolveType, { getSolveTypeInfo } from "@/guiide/ts/solve/solveType";


export default /*@__PURE__*/_defineComponent({
  __name: 'SolveButtons',
  props: {
    scenario: {}
  },
  emits: ["solve-take-less", "solve-pay-more", "solve-equity-release"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

__expose({ setDisabledState, takeFocus });

const props = __props;

const emit = __emit;

const store = useStore();

const solveShortfallsButton = ref(null);
const disableButtons = ref(false);

const hasPensionPots = computed<boolean>(() => store.state.retiree?.pensionPots.pots.length > 0);

const equityReleaseEnabled = computed<boolean>(() => store.state.configuration.solveIncludesEquityRelease);

const mainButtonAriaLabel = computed<string>(() => {
  const scenarioName = ScenarioInfo.getName(props.scenario);
  return `Examine ways of solving the shortfall in the '${scenarioName}' scenario.`
});

function getSolveButtonAriaLabel(solveType: SolveType): string {
  const solveTypeInfo = getSolveTypeInfo(solveType);
  return `Check if the shortfall could be solved by ${solveTypeInfo.gerund}.`
}

function setDisabledState(disabled: boolean) {
  this.disableButtons = disabled;
}

function takeFocus(key: string): boolean {
  solveShortfallsButton.value.focus();
  return true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref_key: "solveShortfallsButton",
      ref: solveShortfallsButton,
      class: "btn btn-solve btn-success dropdown-toggle",
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false",
      "aria-label": mainButtonAriaLabel.value
    }, " Solve shortfalls ", 8, _hoisted_2),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          class: "dropdown-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('solve-take-less'))),
          disabled: disableButtons.value,
          "aria-label": getSolveButtonAriaLabel(_unref(SolveType).TakeLess)
        }, " Take less ", 8, _hoisted_4)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          class: "dropdown-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('solve-pay-more'))),
          disabled: disableButtons.value || !hasPensionPots.value,
          "aria-label": getSolveButtonAriaLabel(_unref(SolveType).PayMore)
        }, " Pay more ", 8, _hoisted_5)
      ]),
      _createElementVNode("li", null, [
        (equityReleaseEnabled.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "dropdown-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('solve-equity-release'))),
              disabled: disableButtons.value,
              "aria-label": getSolveButtonAriaLabel(_unref(SolveType).EquityRelease)
            }, " Home equity ", 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})